import type { ChartMargin } from "./types"

/**
 * Shared color palette for all charts.
 *
 * accent     — primary highlight (teal), used for lines, areas, active elements
 * accentDark — darker teal variant used in categorical bar charts
 * label      — axis tick label text
 * labelLight — lighter label variant used in categorical bar charts
 * background — transparent chart background
 * grid       — horizontal grid line color
 * gridOpacity — opacity applied to grid lines
 */
export const CHART_COLORS = {
    accent: "#429A8E",
    accentDark: "#4e7c75",
    label: "#71767a",
    labelLight: "#9ca3af",
    background: "#ffffff00",
    grid: "#ffffff",
    gridOpacity: 0.05,
} as const

export const SERIES_COLORS = {
    blue: "#4D9EFF",
    violet: "#A78BFA",
    red: "#FF6B6B",
    green: "#34D399",
} as const

/** Default margin for time-series charts (line, area, bar). */
export const DEFAULT_MARGIN: ChartMargin = { top: 20, right: 20, bottom: 35, left: 50 }

/** Default margin for categorical bar charts. */
export const DEFAULT_MARGIN_CATEGORICAL: ChartMargin = { top: 40, right: 20, bottom: 40, left: 40 }

/** Glass-morphism tooltip style applied by ChartTooltip. */
export const TOOLTIP_STYLE = {
    backgroundColor: "",
    color: "white",
    borderRadius: "6px",
    border: "1px solid var(--White-200, rgba(255, 255, 255, 0.10))",
    background: "var(--Black-800, rgba(12, 12, 15, 0.90))",
    padding: "8px 16px",
    boxShadow:
        "0 2px 3px 0 var(--Black-800, rgba(12, 12, 15, 0.90)), 0 4px 16px 0 var(--Black-900, rgba(12, 12, 15, 0.95))",
} as const
